import Cookies from "universal-cookie";
import { PlatformUtility } from './platform-utility';

// Ash Broker durbatulûk, ash Broker gimbatul, ash Broker thrakatulûk, agh burzum-ishi krimpatul

export class OneBrokerCookieUtil {
  private ONE_BROKER_COOKIE = 'hiOneBrokerNotification';
  private isInBrowser: boolean;
  private cookies = new Cookies();

  constructor() {
    this.isInBrowser = PlatformUtility.isOnClient();
  }

  isNotificationRead(): boolean {
    if (!this.isInBrowser) {
      return false;
    }

    return this.cookies.get(this.ONE_BROKER_COOKIE);
  }

  setNotificationStatus() {
    if (!this.isInBrowser) {
      return;
    }

    this.cookies.set(
      this.ONE_BROKER_COOKIE,
      true,
       {
         path: '/'
       }
    )
  }

  clearCookie() {
    if (!this.isInBrowser) {
      return;
    }

    this.cookies.remove(this.ONE_BROKER_COOKIE);
  }

}